import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store, { persistor } from './state/store';
import './index.css';
import { PersistGate } from 'redux-persist/integration/react';
// import { fetchWorkflows } from './state/slices/workflowSlice_working';


// store.dispatch(fetchWorkflows());

const container = document.querySelector('#app');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
